module.exports = __webpack_public_path__ + "static/media/21ECLAC18.1cf5747f.jpg";